import { DetailsPanelSource } from "PFApp/booking/components/details_panel";
import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { useBookings } from "PFCore/hooks/queries";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { Activity } from "PFTypes";

type UseCanViewInBM = {
  activity?: Pick<Activity, "id">;
  parentActivity?: Activity;
  isLoading?: boolean;
  source?: DetailsPanelSource;
};

export const useCanViewActivityInBM = ({ activity }: UseCanViewInBM): boolean => {
  const { data: currentProfile } = useCurrentProfile();

  const {
    isEnabled: isBMEnabled,
    isPermittedToAccess: isPermittedToAccessBM,
    isBookingResourcer
  } = useBookingModulePermissions();

  const { data: bookings } = useBookings(
    { profileId: currentProfile.id, activityId: activity?.id, perPage: 0 },
    { enabled: !isBookingResourcer && !!activity?.id }
  );

  const canSeeBookingModule = isBMEnabled && isPermittedToAccessBM;
  const isCurrentProfileBookedInTheActivity = (bookings?.meta.total || 0) > 0;

  return canSeeBookingModule && (isCurrentProfileBookedInTheActivity || isBookingResourcer);
};
